function formatMoney(cents) {
  cents = Number(cents || 0);

  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    const moneyFormat =
      (window.theme && window.theme.moneyFormat) ||
      window.Shopify.money_format ||
      '${{amount}}';

    return window.Shopify.formatMoney(cents, moneyFormat);
  }

  return `$${(cents / 100).toFixed(2)}`;
}

function refreshStampedBadges() {
  if (!window.StampedFn) return;

  if (typeof window.StampedFn.loadBadges === 'function') {
    window.StampedFn.loadBadges();
    return;
  }

  if (typeof window.StampedFn.reloadWidgets === 'function') {
    window.StampedFn.reloadWidgets();
  }
}

function refreshCartDrawerContents() {
  const cartItemsComponent = document.querySelector('cart-items-component[data-section-id]');
  if (!cartItemsComponent) return Promise.resolve(false);

  const liveSectionId = cartItemsComponent.getAttribute('data-section-id');
  if (!liveSectionId) return Promise.resolve(false);

  const url = `${window.location.pathname}?section_id=${encodeURIComponent(liveSectionId)}`;

  return fetch(url, { credentials: 'same-origin' })
    .then((response) => response.text())
    .then((html) => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newCartItemsComponent = parsed.querySelector('cart-items-component[data-section-id]');
      const currentCartItemsComponent = document.querySelector('cart-items-component[data-section-id]');

      if (!newCartItemsComponent || !currentCartItemsComponent) {
        return false;
      }

      currentCartItemsComponent.innerHTML = newCartItemsComponent.innerHTML;
      refreshStampedBadges();
      return true;
    })
    .catch((error) => {
      console.error('Cart drawer contents refresh failed:', error);
      return false;
    });
}

document.addEventListener('DOMContentLoaded', () => {
  refreshStampedBadges();
});

document.addEventListener('shopify:section:load', () => {
  refreshStampedBadges();
});

document.addEventListener('click', function (event) {
  const variantButton = event.target.closest('[data-upsell-variant-btn]');
  if (variantButton) {
    const card = variantButton.closest('[data-upsell-card]');
    if (!card) return;

    const allButtons = card.querySelectorAll('[data-upsell-variant-btn]');
    const addButton = card.querySelector('[data-upsell-add]');
    const priceEl = card.querySelector('[data-upsell-price]');

    allButtons.forEach((btn) => btn.classList.remove('is-active'));
    variantButton.classList.add('is-active');

    if (addButton) {
      addButton.dataset.variantId = variantButton.dataset.variantId;
      addButton.disabled = variantButton.disabled;
      addButton.textContent = variantButton.disabled ? 'Sold out' : 'Add';
    }

    if (priceEl && variantButton.dataset.price) {
      priceEl.innerHTML = formatMoney(variantButton.dataset.price);
    }

    return;
  }

  const addButton = event.target.closest('[data-upsell-add]');
  if (!addButton) return;
  if (addButton.tagName === 'A') return;

  event.preventDefault();

  const variantId = addButton.dataset.variantId;
  if (!variantId || addButton.disabled) return;

  const originalText = addButton.textContent;
  addButton.disabled = true;
  addButton.textContent = 'Adding...';

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    })
  })
    .then(async (response) => {
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || 'Add to cart failed');
      }

      return data;
    })
    .then(() => {
      return refreshCartDrawerContents();
    })
    .then(() => {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    })
    .catch((error) => {
      console.error('Upsell add failed:', error);
      addButton.disabled = false;
      addButton.textContent = originalText;
    });
});